module.exports = __webpack_public_path__ + "img/preview.6323cb88.svg";